
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hbbek", function(module, exports) {

$parcel$export(module.exports, "$", () => $e75a6c24923c03f0$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "J", () => $e75a6c24923c03f0$export$b4171a6734a65d42);
$parcel$export(module.exports, "q", () => $e75a6c24923c03f0$export$9e5f44173e64f162);
$parcel$export(module.exports, "X", () => $e75a6c24923c03f0$export$78acf4525d8a74c4);
$parcel$export(module.exports, "Q", () => $e75a6c24923c03f0$export$3722cfe417b6ed86);
$parcel$export(module.exports, "Z", () => $e75a6c24923c03f0$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "K", () => $e75a6c24923c03f0$export$3466f893ebf79586);
$parcel$export(module.exports, "U", () => $e75a6c24923c03f0$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "W", () => $e75a6c24923c03f0$export$71cec2538cb2c617);
$parcel$export(module.exports, "H", () => $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "R", () => $e75a6c24923c03f0$export$db202ddc8be9136);
$parcel$export(module.exports, "B", () => $e75a6c24923c03f0$export$ef35774e6d314e91);
$parcel$export(module.exports, "V", () => $e75a6c24923c03f0$export$e7c866399fa523f5);
$parcel$export(module.exports, "F", () => $e75a6c24923c03f0$export$d66501df72047452);
$parcel$export(module.exports, "L", () => $e75a6c24923c03f0$export$61196ced6d74a310);
$parcel$export(module.exports, "I", () => $e75a6c24923c03f0$export$9bb611d729802a56);
$parcel$export(module.exports, "P", () => $e75a6c24923c03f0$export$56c0d5a1e737357d);
$parcel$export(module.exports, "k", () => $e75a6c24923c03f0$export$342063e11d6c3cad);
$parcel$export(module.exports, "O", () => $e75a6c24923c03f0$export$c4ce752e73470fba);
$parcel$export(module.exports, "A", () => $e75a6c24923c03f0$export$ebd11618f299a286);
$parcel$export(module.exports, "M", () => $e75a6c24923c03f0$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "j", () => $e75a6c24923c03f0$export$35e795649ee09318);
$parcel$export(module.exports, "C", () => $e75a6c24923c03f0$export$e7094788287c5e9b);
$parcel$export(module.exports, "D", () => $e75a6c24923c03f0$export$96f57966bedc81b4);
$parcel$export(module.exports, "T", () => $e75a6c24923c03f0$export$971d5caa766a69d7);
$parcel$export(module.exports, "E", () => $e75a6c24923c03f0$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "w", () => $e75a6c24923c03f0$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e75a6c24923c03f0$export$d141bba7fdc215a3);
$parcel$export(module.exports, "S", () => $e75a6c24923c03f0$export$25ce5a424b770e84);
$parcel$export(module.exports, "_", () => $e75a6c24923c03f0$export$71511d61b312f219);
$parcel$export(module.exports, "y", () => $e75a6c24923c03f0$export$4a5767248b18ef41);
$parcel$export(module.exports, "b", () => $e75a6c24923c03f0$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $e75a6c24923c03f0$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "g", () => $e75a6c24923c03f0$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $e75a6c24923c03f0$export$953cecd6e717a553);
$parcel$export(module.exports, "l", () => $e75a6c24923c03f0$export$882b5998b3b9117c);
$parcel$export(module.exports, "p", () => $e75a6c24923c03f0$export$ffb5f4729a158638);
$parcel$export(module.exports, "d", () => $e75a6c24923c03f0$export$4368d992c4eafac0);
$parcel$export(module.exports, "u", () => $e75a6c24923c03f0$export$3b14a55fb2447963);
$parcel$export(module.exports, "f", () => $e75a6c24923c03f0$export$2d1720544b23b823);
$parcel$export(module.exports, "c", () => $e75a6c24923c03f0$export$db3b6bfb95261072);
$parcel$export(module.exports, "o", () => $e75a6c24923c03f0$export$ae1af26003f05816);
$parcel$export(module.exports, "i", () => $e75a6c24923c03f0$export$23f2a1d2818174ef);
$parcel$export(module.exports, "r", () => $e75a6c24923c03f0$export$43caf9889c228507);
$parcel$export(module.exports, "n", () => $e75a6c24923c03f0$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "t", () => $e75a6c24923c03f0$export$625550452a3fa3ec);
/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ 
var $ecd4d = parcelRequire("ecd4d");

var $5rEEc = parcelRequire("5rEEc");
//#region src/utils/env.ts
const $e75a6c24923c03f0$export$3d8c2f653ac9d0b9 = typeof document !== "undefined";
//#endregion
//#region src/utils/index.ts
/**
* Identity function that returns the value as is.
*
* @param v - the value to return
*
* @internal
*/ const $e75a6c24923c03f0$export$8743009a87fcb00f = (v)=>v;
/**
* Allows differentiating lazy components from functional components and vue-class-component
* @internal
*
* @param component
*/ function $e75a6c24923c03f0$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $e75a6c24923c03f0$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || obj.default && $e75a6c24923c03f0$var$isRouteComponent(obj.default);
}
const $e75a6c24923c03f0$export$b4171a6734a65d42 = Object.assign;
function $e75a6c24923c03f0$export$9e5f44173e64f162(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $e75a6c24923c03f0$export$78acf4525d8a74c4(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $e75a6c24923c03f0$export$3722cfe417b6ed86 = ()=>{};
/**
* Typesafe alternative to Array.isArray
* https://github.com/microsoft/TypeScript/pull/48228
*
* @internal
*/ const $e75a6c24923c03f0$export$78acf4525d8a74c4 = Array.isArray;
function $e75a6c24923c03f0$export$dc98b0b04f4c7758(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
//#endregion
//#region src/warning.ts
function $e75a6c24923c03f0$export$3466f893ebf79586(msg) {
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
//#endregion
//#region src/encoding.ts
/**
* Encoding Rules (␣ = Space)
* - Path: ␣ " < > # ? { }
* - Query: ␣ " < > # & =
* - Hash: ␣ " < > `
*
* On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
* defines some extra characters to be encoded. Most browsers do not encode them
* in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
* also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
* plus `-._~`. This extra safety should be applied to query by patching the
* string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
* should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
* into a `/` if directly typed in. The _backtick_ (`````) should also be
* encoded everywhere because some browsers like FF encode it when directly
* written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
*/ const $e75a6c24923c03f0$var$HASH_RE = /#/g;
const $e75a6c24923c03f0$var$AMPERSAND_RE = /&/g;
const $e75a6c24923c03f0$var$SLASH_RE = /\//g;
const $e75a6c24923c03f0$var$EQUAL_RE = /=/g;
const $e75a6c24923c03f0$var$IM_RE = /\?/g;
const $e75a6c24923c03f0$var$PLUS_RE = /\+/g;
/**
* NOTE: It's not clear to me if we should encode the + symbol in queries, it
* seems to be less flexible than not doing so and I can't find out the legacy
* systems requiring this for regular requests like text/html. In the standard,
* the encoding of the plus character is only mentioned for
* application/x-www-form-urlencoded
* (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
* leave the plus character as is in queries. To be more flexible, we allow the
* plus character on the query, but it can also be manually encoded by the user.
*
* Resources:
* - https://url.spec.whatwg.org/#urlencoded-parsing
* - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
*/ const $e75a6c24923c03f0$var$ENC_BRACKET_OPEN_RE = /%5B/g;
const $e75a6c24923c03f0$var$ENC_BRACKET_CLOSE_RE = /%5D/g;
const $e75a6c24923c03f0$var$ENC_CARET_RE = /%5E/g;
const $e75a6c24923c03f0$var$ENC_BACKTICK_RE = /%60/g;
const $e75a6c24923c03f0$var$ENC_CURLY_OPEN_RE = /%7B/g;
const $e75a6c24923c03f0$var$ENC_PIPE_RE = /%7C/g;
const $e75a6c24923c03f0$var$ENC_CURLY_CLOSE_RE = /%7D/g;
const $e75a6c24923c03f0$var$ENC_SPACE_RE = /%20/g;
/**
* Encode characters that need to be encoded on the path, search and hash
* sections of the URL.
*
* @internal
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$var$commonEncode(text) {
    return text == null ? "" : encodeURI("" + text).replace($e75a6c24923c03f0$var$ENC_PIPE_RE, "|").replace($e75a6c24923c03f0$var$ENC_BRACKET_OPEN_RE, "[").replace($e75a6c24923c03f0$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
* Encode characters that need to be encoded on the hash section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$export$3a6d5c9ae78a2c08(text) {
    return $e75a6c24923c03f0$var$commonEncode(text).replace($e75a6c24923c03f0$var$ENC_CURLY_OPEN_RE, "{").replace($e75a6c24923c03f0$var$ENC_CURLY_CLOSE_RE, "}").replace($e75a6c24923c03f0$var$ENC_CARET_RE, "^");
}
/**
* Encode characters that need to be encoded query values on the query
* section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$var$encodeQueryValue(text) {
    return $e75a6c24923c03f0$var$commonEncode(text).replace($e75a6c24923c03f0$var$PLUS_RE, "%2B").replace($e75a6c24923c03f0$var$ENC_SPACE_RE, "+").replace($e75a6c24923c03f0$var$HASH_RE, "%23").replace($e75a6c24923c03f0$var$AMPERSAND_RE, "%26").replace($e75a6c24923c03f0$var$ENC_BACKTICK_RE, "`").replace($e75a6c24923c03f0$var$ENC_CURLY_OPEN_RE, "{").replace($e75a6c24923c03f0$var$ENC_CURLY_CLOSE_RE, "}").replace($e75a6c24923c03f0$var$ENC_CARET_RE, "^");
}
/**
* Like `encodeQueryValue` but also encodes the `=` character.
*
* @param text - string to encode
*/ function $e75a6c24923c03f0$var$encodeQueryKey(text) {
    return $e75a6c24923c03f0$var$encodeQueryValue(text).replace($e75a6c24923c03f0$var$EQUAL_RE, "%3D");
}
/**
* Encode characters that need to be encoded on the path section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$export$2329c99376c9d0a4(text) {
    return $e75a6c24923c03f0$var$commonEncode(text).replace($e75a6c24923c03f0$var$HASH_RE, "%23").replace($e75a6c24923c03f0$var$IM_RE, "%3F");
}
/**
* Encode characters that need to be encoded on the path section of the URL as a
* param. This function encodes everything {@link encodePath} does plus the
* slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
* string instead.
*
* @param text - string to encode
* @returns encoded string
*/ function $e75a6c24923c03f0$export$71cec2538cb2c617(text) {
    return $e75a6c24923c03f0$export$2329c99376c9d0a4(text).replace($e75a6c24923c03f0$var$SLASH_RE, "%2F");
}
function $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(text) {
    if (text == null) return null;
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
//#endregion
//#region src/location.ts
const $e75a6c24923c03f0$var$TRAILING_SLASH_RE = /\/$/;
const $e75a6c24923c03f0$var$removeTrailingSlash = (path)=>path.replace($e75a6c24923c03f0$var$TRAILING_SLASH_RE, "");
/**
* Transforms a URI into a normalized history location
*
* @param parseQuery
* @param location - URI to normalize
* @param currentLocation - current absolute location. Allows resolving relative
* paths. Must start with `/`. Defaults to `/`
* @returns a normalized history location
*/ function $e75a6c24923c03f0$export$db202ddc8be9136(parseQuery$1, location, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    const hashPos = location.indexOf("#");
    let searchPos = location.indexOf("?");
    searchPos = hashPos >= 0 && searchPos > hashPos ? -1 : searchPos;
    if (searchPos >= 0) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos, hashPos > 0 ? hashPos : location.length);
        query = parseQuery$1(searchString.slice(1));
    }
    if (hashPos >= 0) {
        path = path || location.slice(0, hashPos);
        hash = location.slice(hashPos, location.length);
    }
    path = $e75a6c24923c03f0$export$df995fae86a55f06(path != null ? path : location, currentLocation);
    return {
        fullPath: path + searchString + hash,
        path: path,
        query: query,
        hash: $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(hash)
    };
}
function $e75a6c24923c03f0$export$a07804094c3ecf2d(stringifyQuery$1, path, query, hash = "") {
    const searchText = stringifyQuery$1(query);
    return path + (searchText && "?") + searchText + $e75a6c24923c03f0$export$3a6d5c9ae78a2c08(hash);
}
/**
* Stringifies a URL object
*
* @param stringifyQuery
* @param location
*/ function $e75a6c24923c03f0$export$ef35774e6d314e91(stringifyQuery$1, location) {
    const query = location.query ? stringifyQuery$1(location.query) : "";
    return location.path + (query && "?") + query + (location.hash || "");
}
/**
* Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
*
* @param pathname - location.pathname
* @param base - base to strip off
*/ function $e75a6c24923c03f0$export$e7c866399fa523f5(pathname, base) {
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
* Checks if two RouteLocation are equal. This means that both locations are
* pointing towards the same {@link RouteRecord} and that all `params`, `query`
* parameters and `hash` are the same
*
* @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
* @param a - first {@link RouteLocation}
* @param b - second {@link RouteLocation}
*/ function $e75a6c24923c03f0$export$d66501df72047452(stringifyQuery$1, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $e75a6c24923c03f0$export$61196ced6d74a310(a.matched[aLastIndex], b.matched[bLastIndex]) && $e75a6c24923c03f0$export$9bb611d729802a56(a.params, b.params) && stringifyQuery$1(a.query) === stringifyQuery$1(b.query) && a.hash === b.hash;
}
/**
* Check if two `RouteRecords` are equal. Takes into account aliases: they are
* considered equal to the `RouteRecord` they are aliasing.
*
* @param a - first {@link RouteRecord}
* @param b - second {@link RouteRecord}
*/ function $e75a6c24923c03f0$export$61196ced6d74a310(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $e75a6c24923c03f0$export$9bb611d729802a56(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a)if (!$e75a6c24923c03f0$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    return true;
}
function $e75a6c24923c03f0$var$isSameRouteLocationParamsValue(a, b) {
    return $e75a6c24923c03f0$export$78acf4525d8a74c4(a) ? $e75a6c24923c03f0$var$isEquivalentArray(a, b) : $e75a6c24923c03f0$export$78acf4525d8a74c4(b) ? $e75a6c24923c03f0$var$isEquivalentArray(b, a) : a?.valueOf() === b?.valueOf();
}
/**
* Check if two arrays are the same or if an array with one single entry is the
* same as another primitive value. Used to check query and parameters
*
* @param a - array of values
* @param b - array of values or a single value
*/ function $e75a6c24923c03f0$var$isEquivalentArray(a, b) {
    return $e75a6c24923c03f0$export$78acf4525d8a74c4(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
* Resolves a relative path that starts with `.`.
*
* @param to - path location we are resolving
* @param from - currentLocation.path, should start with `/`
*/ function $e75a6c24923c03f0$export$df995fae86a55f06(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        if (segment === ".") continue;
        if (segment === "..") {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
* Initial route location where the router is. Can be used in navigation guards
* to differentiate the initial navigation.
*
* @example
* ```js
* import { START_LOCATION } from 'vue-router'
*
* router.beforeEach((to, from) => {
*   if (from === START_LOCATION) {
*     // initial navigation
*   }
* })
* ```
*/ const $e75a6c24923c03f0$export$56c0d5a1e737357d = {
    path: "/",
    name: void 0,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: void 0
};
//#endregion
//#region src/history/common.ts
let $e75a6c24923c03f0$export$342063e11d6c3cad = /* @__PURE__ */ function(NavigationType$1) {
    NavigationType$1["pop"] = "pop";
    NavigationType$1["push"] = "push";
    return NavigationType$1;
}({});
let $e75a6c24923c03f0$export$c4ce752e73470fba = /* @__PURE__ */ function(NavigationDirection$1) {
    NavigationDirection$1["back"] = "back";
    NavigationDirection$1["forward"] = "forward";
    NavigationDirection$1["unknown"] = "";
    return NavigationDirection$1;
}({});
/**
* Starting location for Histories
*/ const $e75a6c24923c03f0$export$ebd11618f299a286 = "";
/**
* Normalizes a base by removing any trailing slash and reading the base tag if
* present.
*
* @param base - base to normalize
*/ function $e75a6c24923c03f0$export$3a1a48c8f6ef640e(base) {
    if (!base) {
        if ($e75a6c24923c03f0$export$3d8c2f653ac9d0b9) {
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    return $e75a6c24923c03f0$var$removeTrailingSlash(base);
}
const $e75a6c24923c03f0$var$BEFORE_HASH_RE = /^[^#]+#/;
function $e75a6c24923c03f0$export$35e795649ee09318(base, location) {
    return base.replace($e75a6c24923c03f0$var$BEFORE_HASH_RE, "#") + location;
}
//#endregion
//#region src/scrollBehavior.ts
function $e75a6c24923c03f0$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $e75a6c24923c03f0$export$e7094788287c5e9b = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $e75a6c24923c03f0$export$96f57966bedc81b4(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $e75a6c24923c03f0$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $e75a6c24923c03f0$export$971d5caa766a69d7(path, delta) {
    return (history.state ? history.state.position - delta : -1) + path;
}
const $e75a6c24923c03f0$var$scrollPositions = /* @__PURE__ */ new Map();
function $e75a6c24923c03f0$export$a9c23c6ac3fc3eca(key, scrollPosition) {
    $e75a6c24923c03f0$var$scrollPositions.set(key, scrollPosition);
}
function $e75a6c24923c03f0$export$efccba1c4a2ef57b(key) {
    const scroll = $e75a6c24923c03f0$var$scrollPositions.get(key);
    $e75a6c24923c03f0$var$scrollPositions.delete(key);
    return scroll;
}
/**
* ScrollBehavior instance used by the router to compute and restore the scroll
* position when navigating.
*/ //#endregion
//#region src/types/typeGuards.ts
function $e75a6c24923c03f0$export$d141bba7fdc215a3(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $e75a6c24923c03f0$export$25ce5a424b770e84(name) {
    return typeof name === "string" || typeof name === "symbol";
}
//#endregion
//#region src/errors.ts
/**
* Flags so we can combine them when checking for multiple errors. This is the internal version of
* {@link NavigationFailureType}.
*
* @internal
*/ let $e75a6c24923c03f0$export$71511d61b312f219 = /* @__PURE__ */ function(ErrorTypes$1) {
    ErrorTypes$1[ErrorTypes$1["MATCHER_NOT_FOUND"] = 1] = "MATCHER_NOT_FOUND";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_GUARD_REDIRECT"] = 2] = "NAVIGATION_GUARD_REDIRECT";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_ABORTED"] = 4] = "NAVIGATION_ABORTED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_CANCELLED"] = 8] = "NAVIGATION_CANCELLED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_DUPLICATED"] = 16] = "NAVIGATION_DUPLICATED";
    return ErrorTypes$1;
}({});
const $e75a6c24923c03f0$var$NavigationFailureSymbol = Symbol("");
/**
* Enumeration with all possible types for navigation failures. Can be passed to
* {@link isNavigationFailure} to check for specific failures.
*/ let $e75a6c24923c03f0$export$90a7f3efeed30595 = /* @__PURE__ */ function(NavigationFailureType$1) {
    /**
	* An aborted navigation is a navigation that failed because a navigation
	* guard returned `false` or called `next(false)`
	*/ NavigationFailureType$1[NavigationFailureType$1["aborted"] = 4] = "aborted";
    /**
	* A cancelled navigation is a navigation that failed because a more recent
	* navigation finished started (not necessarily finished).
	*/ NavigationFailureType$1[NavigationFailureType$1["cancelled"] = 8] = "cancelled";
    /**
	* A duplicated navigation is a navigation that failed because it was
	* initiated while already being at the exact same location.
	*/ NavigationFailureType$1[NavigationFailureType$1["duplicated"] = 16] = "duplicated";
    return NavigationFailureType$1;
}({});
const $e75a6c24923c03f0$var$ErrorTypeMessages = {
    [$e75a6c24923c03f0$export$71511d61b312f219.MATCHER_NOT_FOUND] ({ location: location, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$e75a6c24923c03f0$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_ABORTED] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_CANCELLED] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [$e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_DUPLICATED] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
* Creates a typed NavigationFailure object.
* @internal
* @param type - NavigationFailureType
* @param params - { from, to }
*/ function $e75a6c24923c03f0$export$4a5767248b18ef41(type, params) {
    return $e75a6c24923c03f0$export$b4171a6734a65d42(/* @__PURE__ */ new Error(), {
        type: type,
        [$e75a6c24923c03f0$var$NavigationFailureSymbol]: true
    }, params);
}
function $e75a6c24923c03f0$export$8b22cf2602fb60ce(error, type) {
    return error instanceof Error && $e75a6c24923c03f0$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $e75a6c24923c03f0$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $e75a6c24923c03f0$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location = {};
    for (const key of $e75a6c24923c03f0$var$propertiesToLog)if (key in to) location[key] = to[key];
    return JSON.stringify(location, null, 2);
}
//#endregion
//#region src/query.ts
/**
* Transforms a queryString into a {@link LocationQuery} object. Accept both, a
* version with the leading `?` and without Should work as URLSearchParams

* @internal
*
* @param search - search string to parse
* @returns a query object
*/ function $e75a6c24923c03f0$export$dda1d9f60106f0e9(search) {
    const query = {};
    if (search === "" || search === "?") return query;
    const searchParams = (search[0] === "?" ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        const searchParam = searchParams[i].replace($e75a6c24923c03f0$var$PLUS_RE, " ");
        const eqPos = searchParam.indexOf("=");
        const key = $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(searchParam.slice(eqPos + 1));
        if (key in query) {
            let currentValue = query[key];
            if (!$e75a6c24923c03f0$export$78acf4525d8a74c4(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
* Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
* doesn't prepend a `?`
*
* @internal
*
* @param query - query object to stringify
* @returns string version of the query without the leading `?`
*/ function $e75a6c24923c03f0$export$39b482c5e57630a8(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $e75a6c24923c03f0$var$encodeQueryKey(key);
        if (value == null) {
            if (value !== void 0) search += (search.length ? "&" : "") + key;
            continue;
        }
        ($e75a6c24923c03f0$export$78acf4525d8a74c4(value) ? value.map((v)=>v && $e75a6c24923c03f0$var$encodeQueryValue(v)) : [
            value && $e75a6c24923c03f0$var$encodeQueryValue(value)
        ]).forEach((value$1)=>{
            if (value$1 !== void 0) {
                search += (search.length ? "&" : "") + key;
                if (value$1 != null) search += "=" + value$1;
            }
        });
    }
    return search;
}
/**
* Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
* numbers into strings, removing keys with an undefined value and replacing
* undefined with null in arrays
*
* @param query - query object to normalize
* @returns a normalized query object
*/ function $e75a6c24923c03f0$export$953cecd6e717a553(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== void 0) normalizedQuery[key] = $e75a6c24923c03f0$export$78acf4525d8a74c4(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
//#endregion
//#region src/injectionSymbols.ts
/**
* RouteRecord being rendered by the closest ancestor Router View. Used for
* `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
* Location Matched
*
* @internal
*/ const $e75a6c24923c03f0$export$882b5998b3b9117c = Symbol("");
/**
* Allows overriding the router view depth to control which component in
* `matched` is rendered. rvd stands for Router View Depth
*
* @internal
*/ const $e75a6c24923c03f0$export$ffb5f4729a158638 = Symbol("");
/**
* Allows overriding the router instance returned by `useRouter` in tests. r
* stands for router
*
* @internal
*/ const $e75a6c24923c03f0$export$4368d992c4eafac0 = Symbol("");
/**
* Allows overriding the current route returned by `useRoute` in tests. rl
* stands for route location
*
* @internal
*/ const $e75a6c24923c03f0$export$3b14a55fb2447963 = Symbol("");
/**
* Allows overriding the current route used by router-view. Internally this is
* used when the `route` prop is passed.
*
* @internal
*/ const $e75a6c24923c03f0$export$2d1720544b23b823 = Symbol("");
//#endregion
//#region src/utils/callbacks.ts
/**
* Create a list of callbacks that can be reset. Used to create before and after navigation guards list
*/ function $e75a6c24923c03f0$export$db3b6bfb95261072() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
//#endregion
//#region src/navigationGuards.ts
function $e75a6c24923c03f0$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $ecd4d.onUnmounted)(removeFromList);
    (0, $ecd4d.onDeactivated)(removeFromList);
    (0, $ecd4d.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
* Add a navigation guard that triggers whenever the component for the current
* location is about to be left. Similar to {@link beforeRouteLeave} but can be
* used in any component. The guard is removed when the component is unmounted.
*
* @param leaveGuard - {@link NavigationGuard}
*/ function $e75a6c24923c03f0$export$ae1af26003f05816(leaveGuard) {
    const activeRecord = (0, $ecd4d.inject)($e75a6c24923c03f0$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $e75a6c24923c03f0$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
* Add a navigation guard that triggers whenever the current location is about
* to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
* component. The guard is removed when the component is unmounted.
*
* @param updateGuard - {@link NavigationGuard}
*/ function $e75a6c24923c03f0$export$2408f22a0fab9ae5(updateGuard) {
    const activeRecord = (0, $ecd4d.inject)($e75a6c24923c03f0$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $e75a6c24923c03f0$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $e75a6c24923c03f0$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    const enterCallbackArray = record && (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($e75a6c24923c03f0$export$4a5767248b18ef41($e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_ABORTED, {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($e75a6c24923c03f0$export$d141bba7fdc215a3(valid)) reject($e75a6c24923c03f0$export$4a5767248b18ef41($e75a6c24923c03f0$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT, {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $e75a6c24923c03f0$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $e75a6c24923c03f0$export$3466f893ebf79586(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $e75a6c24923c03f0$export$43caf9889c228507(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($e75a6c24923c03f0$var$isRouteComponent(rawComponent)) {
            const guard = (rawComponent.__vccOpts || rawComponent)[guardType];
            guard && guards.push($e75a6c24923c03f0$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext));
        } else {
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = $e75a6c24923c03f0$var$isESModule(resolved) ? resolved.default : resolved;
                    record.mods[name] = resolved;
                    record.components[name] = resolvedComponent;
                    const guard = (resolvedComponent.__vccOpts || resolvedComponent)[guardType];
                    return guard && $e75a6c24923c03f0$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
* Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
*
* @param route - resolved route to load
*/ function $e75a6c24923c03f0$export$407448d2b89b1813(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(/* @__PURE__ */ new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(/* @__PURE__ */ new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $e75a6c24923c03f0$var$isESModule(resolved) ? resolved.default : resolved;
                record.mods[name] = resolved;
                record.components[name] = resolvedComponent;
            }));
            return promises;
        }, [])))).then(()=>route);
}
/**
* Split the leaving, updating, and entering records.
* @internal
*
* @param  to - Location we are navigating to
* @param from - Location we are navigating from
*/ function $e75a6c24923c03f0$export$7ccc53e8f1e7dfc5(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$e75a6c24923c03f0$export$61196ced6d74a310(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) {
            if (!from.matched.find((record)=>$e75a6c24923c03f0$export$61196ced6d74a310(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
//#endregion
//#region src/devtools.ts
/**
* Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
*
* @param routeLocation - routeLocation to format
* @param tooltip - optional tooltip
* @returns a copy of the routeLocation
*/ function $e75a6c24923c03f0$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $e75a6c24923c03f0$export$b4171a6734a65d42({}, routeLocation, {
        matched: routeLocation.matched.map((matched)=>$e75a6c24923c03f0$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $e75a6c24923c03f0$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
let $e75a6c24923c03f0$var$routerId = 0;
function $e75a6c24923c03f0$export$625550452a3fa3ec(app, router, matcher) {
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    const id = $e75a6c24923c03f0$var$routerId++;
    (0, $5rEEc.setupDevtoolsPlugin)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $e75a6c24923c03f0$export$3466f893ebf79586("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $e75a6c24923c03f0$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $e75a6c24923c03f0$var$PINK_500
                });
            }
            if ($e75a6c24923c03f0$export$78acf4525d8a74c4(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $e75a6c24923c03f0$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $e75a6c24923c03f0$var$RED_100;
                        textColor = $e75a6c24923c03f0$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $e75a6c24923c03f0$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $e75a6c24923c03f0$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $ecd4d.watch)(router.currentRoute, ()=>{
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 4237508
        });
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $e75a6c24923c03f0$var$formatDisplay("beforeEach"),
                from: $e75a6c24923c03f0$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $e75a6c24923c03f0$var$formatRouteLocation(to, "Target location")
            };
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $e75a6c24923c03f0$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $e75a6c24923c03f0$var$formatDisplay("\u274C");
            } else data.status = $e75a6c24923c03f0$var$formatDisplay("\u2705");
            data.from = $e75a6c24923c03f0$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $e75a6c24923c03f0$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
		* Inspector of Existing routes
		*/ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            let routes = matcher.getRoutes().filter((route)=>!route.parent || !route.parent.record.components);
            routes.forEach($e75a6c24923c03f0$var$resetMatchStateOnRouteRecord);
            if (payload.filter) routes = routes.filter((route)=>$e75a6c24923c03f0$var$isRouteMatching(route, payload.filter.toLowerCase()));
            routes.forEach((route)=>$e75a6c24923c03f0$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($e75a6c24923c03f0$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
		* Display information about the currently selected route record
		*/ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const route = matcher.getRoutes().find((route$1)=>route$1.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $e75a6c24923c03f0$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $e75a6c24923c03f0$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $e75a6c24923c03f0$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$e75a6c24923c03f0$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
* Extracted from tailwind palette
*/ const $e75a6c24923c03f0$var$PINK_500 = 15485081;
const $e75a6c24923c03f0$var$BLUE_600 = 2450411;
const $e75a6c24923c03f0$var$LIME_500 = 8702998;
const $e75a6c24923c03f0$var$CYAN_400 = 2282478;
const $e75a6c24923c03f0$var$ORANGE_400 = 16486972;
const $e75a6c24923c03f0$var$DARK = 6710886;
const $e75a6c24923c03f0$var$RED_100 = 16704226;
const $e75a6c24923c03f0$var$RED_700 = 12131356;
function $e75a6c24923c03f0$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $e75a6c24923c03f0$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 16777215,
        backgroundColor: $e75a6c24923c03f0$var$DARK
    });
    let id = record.__vd_id;
    if (id == null) {
        id = String($e75a6c24923c03f0$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($e75a6c24923c03f0$var$formatRouteRecordForInspector)
    };
}
let $e75a6c24923c03f0$var$routeRecordId = 0;
const $e75a6c24923c03f0$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $e75a6c24923c03f0$var$markRouteRecordActive(route, currentRoute) {
    const isExactActive = currentRoute.matched.length && $e75a6c24923c03f0$export$61196ced6d74a310(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$e75a6c24923c03f0$export$61196ced6d74a310(match, route.record));
    route.children.forEach((childRoute)=>$e75a6c24923c03f0$var$markRouteRecordActive(childRoute, currentRoute));
}
function $e75a6c24923c03f0$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($e75a6c24923c03f0$var$resetMatchStateOnRouteRecord);
}
function $e75a6c24923c03f0$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($e75a6c24923c03f0$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    if (new RegExp(found[1].replace(/\$$/, ""), found[2]).test(filter)) {
        route.children.forEach((child)=>$e75a6c24923c03f0$var$isRouteMatching(child, filter));
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $e75a6c24923c03f0$export$7f8ddf7c7c20b3cd(path);
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$e75a6c24923c03f0$var$isRouteMatching(child, filter));
}
function $e75a6c24923c03f0$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) ret[key] = obj[key];
    return ret;
}

});
parcelRegister("5rEEc", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $3f6f0114ed3dd677$export$63b9a9bba9f20f3e);

var $7OjwC = parcelRequire("7OjwC");

var $dfHmV = parcelRequire("dfHmV");

var $cXchM = parcelRequire("cXchM");



function $3f6f0114ed3dd677$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $7OjwC.getTarget)();
    const hook = (0, $7OjwC.getDevtoolsGlobalHook)();
    const enableProxy = (0, $7OjwC.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $dfHmV.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $cXchM.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("7OjwC", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $5afc5936d242b3fa$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $5afc5936d242b3fa$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $5afc5936d242b3fa$export$bc32a04c49ed7464);
function $5afc5936d242b3fa$export$5a2d366b2d9f38f6() {
    return $5afc5936d242b3fa$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $5afc5936d242b3fa$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $5afc5936d242b3fa$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("dfHmV", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $9a5e5137e8e0d980$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $9a5e5137e8e0d980$export$a0897f44accbe922);
const $9a5e5137e8e0d980$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $9a5e5137e8e0d980$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("cXchM", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $96e48670ada1e8d9$export$5728f3776e9b2ac1);

var $dfHmV = parcelRequire("dfHmV");

var $fhEzc = parcelRequire("fhEzc");
class $96e48670ada1e8d9$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $fhEzc.now)();
            }
        };
        if (hook) hook.on((0, $dfHmV.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("fhEzc", function(module, exports) {

$parcel$export(module.exports, "now", () => $b207e93fccd7ac25$export$461939dd4422153);
let $b207e93fccd7ac25$var$supported;
let $b207e93fccd7ac25$var$perf;
function $b207e93fccd7ac25$export$70d26280bc1ca547() {
    var _a;
    if ($b207e93fccd7ac25$var$supported !== undefined) return $b207e93fccd7ac25$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $b207e93fccd7ac25$var$supported = true;
        $b207e93fccd7ac25$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $b207e93fccd7ac25$var$supported = true;
        $b207e93fccd7ac25$var$perf = globalThis.perf_hooks.performance;
    } else $b207e93fccd7ac25$var$supported = false;
    return $b207e93fccd7ac25$var$supported;
}
function $b207e93fccd7ac25$export$461939dd4422153() {
    return $b207e93fccd7ac25$export$70d26280bc1ca547() ? $b207e93fccd7ac25$var$perf.now() : Date.now();
}

});





//# sourceMappingURL=Dashboard.95035211.js.map
